export const
  GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY,
  GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "72175597826-rdqppphjmrt6jl9dfrlspnbphme4gfka.apps.googleusercontent.com",
  CALENDAR_ID = process.env.REACT_APP_CALENDAR_ID || "primary"
